import React from 'react'
import type { EventDetails } from '@mobi/betslip/types'
import { isRaceDetails } from '@mobi/betslip/helpers/typeGuards'
import { RaceNotificationButton } from '@core/Areas/Racing/Components/RaceNotificationButton'
import { ReceiptButtonStyled } from '@core/Areas/Quickbet/Components/Receipt/Components/Common/Receipt.styles'

export const RaceAlertButton: React.FC<{ selectionDetails: EventDetails | null }> = ({
  selectionDetails,
}) => {
  if (!isRaceDetails(selectionDetails)) return null
  if (selectionDetails.races.length > 1) return null

  return (
    <RaceNotificationButton
      raceStatus='Open'
      raceTime={new Date(selectionDetails.races[0].raceTime)}
      meetingId={selectionDetails.races[0].meetingId}
      raceNumber={selectionDetails.races[0].raceNumber}
      meetingName={selectionDetails.races[0].meetingName}
      meetingDate={selectionDetails.races[0].meetingDate}
      buttonComponent={ButtonComponent}
    />
  )
}

// ===============
// Local Component
// ===============

const ButtonComponent: React.FC<React.HTMLAttributes<HTMLButtonElement>> = ({
  onClick,
  children,
  ...attributes
}) => (
  <ReceiptButtonStyled
    // @ts-expect-error Prop name clashes with attribute
    color='secondary'
    type='button'
    role='button'
    onClick={onClick}
    {...attributes}
  >
    {children} Set Alert
  </ReceiptButtonStyled>
)
